import React from 'react'
import { GoodThings } from './Components/GoodThings'
import { CurrentGoodThings, CurrentGoodThingsKey } from './data-access/giddyUpGoodThings'

export const GoodThingsPage: React.FC = () => {
  React.useEffect(() => {
    CurrentGoodThings.getPromise(CurrentGoodThingsKey)
  }, [])

  return <GoodThings />
}
